import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=d97ccc22"
import script from "./file-upload.vue?vue&type=script&lang=js"
export * from "./file-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../voice-2025/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports